export enum SortDirection {
   Ascending = 'Ascending',
   Descending = 'Descending'
}
